export const TENDER_STAGE_LABELS = {
  STALE_PRE_TENDER: "Stale pre-tender",
  PRE_TENDER: "Pre-tender",
  OPEN: "Open",
  CLOSED: "Closed",
  AWARDED: "Awarded",
} as const;
